module.exports = __webpack_public_path__ + "img/bg.960aa2f5.png";